import api from './client';
import type { PaymentVerificationResponse } from '../../types/api';

export const verifyPayment = async (orderID: string): Promise<PaymentVerificationResponse> => {
  return api.post<any, PaymentVerificationResponse>('/api/payments/verify', { orderID });
};